module.exports = __webpack_public_path__ + "img/fi-hr-p.20dcfaf0.png";